import React from 'react';
import { SEOHead } from '../components/common/SEOHead';
import { Breadcrumbs } from '../components/common/Breadcrumbs';

export default function PrivacyPolicyPage() {
  return (
    <>
      <SEOHead
        title="Privacy Policy"
        description="Privacy Policy for Silver Perfumes. Learn how we collect, use, and protect your personal information."
        canonical="https://silverperfumes.thevinculum.org.in/privacy-policy"
      />

      <section className="pt-32 pb-8 bg-[#0A0A0A]">
        <div className="container-custom">
          <Breadcrumbs items={[{ label: 'Privacy Policy' }]} />
          <h1 className="heading-xl text-white mt-6">Privacy Policy</h1>
        </div>
      </section>

      <section className="py-16 bg-white" data-testid="privacy-content">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p className="text-gray-500 mb-8">Last updated: January 2024</p>

            <h2 className="heading-md mb-4">1. Introduction</h2>
            <p className="text-gray-600 mb-6">
              Silver Perfumes ("we," "our," or "us") respects your privacy and is committed 
              to protecting your personal data. This privacy policy explains how we collect, 
              use, and safeguard your information when you visit our website or engage with 
              our services.
            </p>

            <h2 className="heading-md mb-4">2. Information We Collect</h2>
            <p className="text-gray-600 mb-4">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Personal identification information (name, email, phone number, company name)</li>
              <li>Business information for B2B transactions</li>
              <li>Technical data (IP address, browser type, device information)</li>
              <li>Usage data (pages visited, time spent on site)</li>
            </ul>

            <h2 className="heading-md mb-4">3. How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Process your inquiries and provide quotes</li>
              <li>Communicate with you about products and services</li>
              <li>Improve our website and customer service</li>
              <li>Send promotional materials (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="heading-md mb-4">4. Data Security</h2>
            <p className="text-gray-600 mb-6">
              We implement appropriate security measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, 
              no method of transmission over the Internet is 100% secure.
            </p>

            <h2 className="heading-md mb-4">5. Third-Party Sharing</h2>
            <p className="text-gray-600 mb-6">
              We do not sell your personal information. We may share your data with trusted 
              service providers who assist us in operating our website and conducting business, 
              subject to confidentiality agreements.
            </p>

            <h2 className="heading-md mb-4">6. Your Rights</h2>
            <p className="text-gray-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="heading-md mb-4">7. Contact Us</h2>
            <p className="text-gray-600 mb-6">
              If you have questions about this privacy policy, please contact us at:<br />
              Email: silverperfumes108@gmail.com<br />
              Phone: +91 9998863360
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
